var kind      = require("enyo/kind"),
    themeVars = require("app/theme/PageBackgroundVariables");

require("app/ui/PageBackgroundSupport.less");

/**
 * [PageBackgroundSupport]{@link app.ui.PageBackgroundSupport} adds a responsive
 * background to components.
 *
 * @mixin     app.ui.PageBackgroundSupport
 * @requires  app.ui.ImageOptimizerSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "app.ui.PageBackgroundSupport",

    /**
     * @name     rawBackgroundImageSrc
     * @type     {string}
     * @memberof app.ui.PageBackgroundSupport
     * @public
     */

    /**
     * @name     imageResolutionStepSize
     * @type     {int}
     * @memberof app.ui.PageBackgroundSupport
     * @public
     */

    /**
     * @memberof app.ui.PageBackgroundSupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            if (this.rawBackgroundImageSrc === undefined) {
                this.rawBackgroundImageSrc = require("app/theme/assets/page-background.png");
            }

            if (this.imageResolutionStepSize === undefined) {
                this.imageResolutionStepSize = 480;
            }

            this.addClass("app-ui-page-background");
            this.rawBackgroundImageSrcChanged();
        };
    }),

    /**
     * @private
     */
    rawBackgroundImageSrcChanged: function() {
        var src = this.get("rawBackgroundImageSrc");

        this.set("rawImageSrc", src ? {
            width:  themeVars.backgroundWidth || null,
            height: themeVars.backgroundHeight || null,
            ratio:  themeVars.backgroundRatio || null,
            src:    src
        } : null);
    }

};
